import React from 'react';
import { SecurityContextTemplate } from 'framework/authorization';
import useVendorService from './useVendorService';

const VENDOR_SECURITY_CONTEXT = 'vendor';

const VendorSecurityContext = ({
  permissionToCheck,
  children,
}: {
  permissionToCheck: string | string[];
  children: React.ReactNode;
}) => {
  const { getPermissionsEntity } = useVendorService();

  return (
    <SecurityContextTemplate
      getPermissionsFunc={getPermissionsEntity}
      permissionToCheck={permissionToCheck}
      contextName={VENDOR_SECURITY_CONTEXT}
    >
      {children}
    </SecurityContextTemplate>
  );
};

export default VendorSecurityContext;
